import { styled } from '@mui/material/styles';
import { IconButton } from 'components/buttons';
import { FormContainer } from 'components/styledComponents';

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  /**
   * @TODO find a better way for spacing
   * https://jira.atreus.de/browse/MILK-643
   */
  alignSelf: 'flex-start',
  margin: theme.spacing(2.375, 0),
  transform: `translateX(${theme.spacing(1)})`,

  color: theme.color.danger.main,
  border: `1px solid transparent`,

  '&:hover': {
    border: `1px solid ${theme.color.danger.main}`
  },
  '&:active': {
    border: `1px solid ${theme.color.danger.main}`
  }
}));

export const LanguageWrapper = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  [`& ${FormContainer}`]: {
    flexGrow: 1
  }
}));
